/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_SegmentInputs */

const en_st_wl_segment = /** @type {(inputs: St_Wl_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are`)
};

const id_st_wl_segment = /** @type {(inputs: St_Wl_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu`)
};

/**
* | output |
* | --- |
* | "You are" |
*
* @param {St_Wl_SegmentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_segment = /** @type {((inputs?: St_Wl_SegmentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_SegmentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_segment(inputs)
	return en_st_wl_segment(inputs)
});